(function ($) {
  const $body = $("body");

  console.log("navbar v2.4 loaded");

  // ---------------- Helpers ----------------

  function isDesktopLg() {
    // Drawer breakpoint (1024px)
    return window.matchMedia("(min-width: 1024px)").matches;
  }

  function getLabel(el) {
    const $el = $(el);
    const fromData = $el.data("label");

    if (fromData) {
      return String(fromData).trim();
    }

    return $el.text().replace(/\s+/g, " ").trim();
  }

  // Return the URL only if there is a data-hero. Otherwise null.
  function heroUrlFrom(el) {
    const url = $(el).data("hero");
    if (url && String(url).trim() !== "") {
      return url;
    }
    return null;
  }

  // Generic helper: update a hero img + caption pair and hide them if no hero.
  function updateHero($img, $caption, el, fallbackLabel) {
    const url = heroUrlFrom(el);
    const label = getLabel(el) || fallbackLabel || "";

    if (url) {
      $img.attr("src", url).removeClass("hidden");
      $caption.text(label).removeClass("hidden");
    } else {
      $img.addClass("hidden");
      $caption.addClass("hidden").text("");
    }
  }

  function getBackdrop() {
    return $("#drawerBackdrop");
  }

  function showBackdrop(raiseHeader = false) {
    const $backdrop = getBackdrop();
    if ($backdrop.length) {
      $backdrop.removeClass("hidden pointer-events-none").css("opacity", 1);
    }

    // ⬇️ Only bump header z-index if explicitly requested
    if (raiseHeader) {
      const $header = $("header.header-nav-v2");
      if ($header.length) {
        $header.css("z-index", 70000);
      }
    }

    $body.addClass("no-scroll");
  }

  function hideBackdrop() {
    const $backdrop = getBackdrop();
    if ($backdrop.length) {
      $backdrop.addClass("hidden pointer-events-none").css("opacity", 0);
    }

    // Restore original header z-index
    const $header = $("header.header-nav-v2");
    if ($header.length) {
      //   if (headerOldZ !== null) {
      //     $header.css("z-index", headerOldZ);
      //   } else {
      $header.css("z-index", "");
      //   }
    }

    $body.removeClass("no-scroll");
  }

  // Generic “click-to-open” mega menu (Destinations / Envies)
  function setupClickMega($btn, $panel, $allBtns, $allPanels) {
    function open() {
      $allPanels.not($panel).stop(true, true).slideUp(120).removeClass("is-open");

      $allBtns.not($btn).attr("aria-expanded", "false");

      $panel.stop(true, true).slideDown(120).addClass("is-open");

      $btn.attr("aria-expanded", "true");

      showBackdrop(true);
    }

    function close() {
      $panel.stop(true, true).slideUp(120).removeClass("is-open");

      $btn.attr("aria-expanded", "false");

      hideBackdrop();
    }

    function toggle() {
      if ($panel.hasClass("is-open") === true) {
        close();
      } else {
        open();
      }
    }

    // Expose programmatic controls on the button (for #menu-destinations, #menu-envies)
    $btn.data("mega-open", open);
    $btn.data("mega-close", close);

    // Main button events
    $btn.off(".mega");

    $btn.on("click.mega", function (e) {
      e.preventDefault();
      toggle();
    });

    $btn.on("keydown.mega", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggle();
      }
    });

    // Click outside
    const ns = ".mega-" + $panel.attr("id");

    $(document).off("click" + ns);
    $(document).on("click" + ns, function (e) {
      const $target = $(e.target);
      const insidePanel = $target.closest($panel).length > 0;
      const insideButton = $target.closest($btn).length > 0;
      const inside = insidePanel || insideButton;

      if (inside === false && $panel.hasClass("is-open") === true) {
        close();
      }
    });

    // Escape key
    $(document).off("keydown" + ns);
    $(document).on("keydown" + ns, function (e) {
      const isEscape = e.key === "Escape";

      if (isEscape === true && $panel.hasClass("is-open") === true) {
        close();
      }
    });
  }

  // ---------------- Sticky header ----------------

  function initStickyHeader() {
    const $menu = $("header.header-nav-v2");

    if ($menu.length === 0) {
      return;
    }

    function update() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (y > 30) {
        $menu.addClass("fixed");
        $menu.removeClass("relative");
      } else {
        $menu.addClass("relative");
        $menu.removeClass("fixed");
      }
    }

    $(window).on("scroll", update);
    $(window).on("load", update);
    update();
  }

  // ---------------- Phone dropdown ----------------

  function initPhoneDropdown() {
    const $wrap = $("#phoneBlock");
    const $dd = $("#phoneDropdown");

    if ($wrap.length === 0 || $dd.length === 0) {
      return;
    }

    let timer = null;

    function open() {
      clearTimeout(timer);
      $dd.stop(true, true).fadeIn(100);
    }

    function close() {
      timer = setTimeout(function () {
        $dd.stop(true, true).fadeOut(120);
      }, 120);
    }

    $wrap.on("mouseenter", open);
    $wrap.on("focusin", open);

    $wrap.on("mouseleave", close);
    $wrap.on("focusout", close);

    $(document).on("click", function (e) {
      const isInside = $.contains($wrap[0], e.target);

      if (isInside === false) {
        $dd.hide();
      }
    });
  }

  // ---------------- Mega Destinations / Inspirations ----------------

  function initMegaDestinations() {
    const $btn = $("#btnDest").attr("aria-expanded", "false");
    const $panel = $("#megaDestinations").hide();
    const $allBtns = $("#btnDest, #btnInspi");
    const $allPanels = $("#megaDestinations, #megaInspirations");

    if ($btn.length === 0 || $panel.length === 0) {
      return;
    }

    setupClickMega($btn, $panel, $allBtns, $allPanels);

    // Left column (continents)
    const $continentBtns = $(".continent-btn");
    $continentBtns.off(".mega");

    $continentBtns.on("pointerenter.mega", function () {
      const targetSel = $(this).data("target");

      if (!targetSel) {
        return;
      }

      $(".countries-group").removeClass("active").hide();
      $(".continent-btn").removeClass("active");

      $(this).addClass("active");
      $(targetSel).addClass("active").show();

      updateHero($("#destHeroImg"), $("#destHeroLabel"), this);
    });

    $continentBtns.on("focus.mega", function () {
      const targetSel = $(this).data("target");

      if (!targetSel) {
        return;
      }

      $(".countries-group").removeClass("active").hide();
      $(".continent-btn").removeClass("active");

      $(this).addClass("active");
      $(targetSel).addClass("active").show();

      updateHero($("#destHeroImg"), $("#destHeroLabel"), this);
    });

    // Middle column (countries)
    const $countriesLinks = $(".countries-group a");
    $countriesLinks.off(".mega");

    $countriesLinks.on("pointerenter.mega", function () {
      updateHero($("#destHeroImg"), $("#destHeroLabel"), this);
    });

    $countriesLinks.on("focus.mega", function () {
      updateHero($("#destHeroImg"), $("#destHeroLabel"), this);
    });
  }

  function initMegaInspirations() {
    const $btn = $("#btnInspi").attr("aria-expanded", "false");
    const $panel = $("#megaInspirations").hide();
    const $allBtns = $("#btnDest, #btnInspi");
    const $allPanels = $("#megaDestinations, #megaInspirations");

    if ($btn.length === 0 || $panel.length === 0) {
      return;
    }

    setupClickMega($btn, $panel, $allBtns, $allPanels);

    // Delegated events on document (filters, items, etc.)
    $(document).off(".inspi");

    // Main filters (envie / période)
    $(document).on("click.inspi pointerenter.inspi focusin.inspi", ".inspi-filter", function (e) {
      if (e.type === "click") {
        e.preventDefault();
      }

      const $link = $(this);
      const targetSel = $link.data("target");

      $(".inspi-filter").removeClass("active");
      $link.addClass("active");

      if (targetSel) {
        $(".inspi-list").addClass("hidden");
        $(targetSel).removeClass("hidden");
      }

      updateHero($("#inspiHeroImg"), $("#inspiHeroLabel"), this);
    });

    // "Tour du monde" hover/focus
    $(document).on("pointerenter.inspi focusin.inspi", ".inspi-filter-tour", function () {
      updateHero($("#inspiHeroImg"), $("#inspiHeroLabel"), this);
    });

    // Individual inspiration items
    $(document).on("pointerenter.inspi focusin.inspi", ".inspi-item", function () {
      updateHero($("#inspiHeroImg"), $("#inspiHeroLabel"), this);
    });
  }

  // ---------------- 3-column drawer ----------------

  function initDrawer() {
    const $dock = $("#drawerDock");
    const $L1 = $("#drawerL1");
    const $L2 = $("#drawerL2");
    const $L3 = $("#drawerL3");
    const $S2 = $("#drawerStage2");
    const $S3 = $("#drawerStage3");

    if ($dock.length === 0) {
      return;
    }

    let activeL1Trigger = null;
    let activeL2Trigger = null;
    let l2Timer = null;
    let l3Timer = null;

    function setActiveL1(el) {
      if (activeL1Trigger) {
        $(activeL1Trigger).removeClass("drawer-active");
      }

      activeL1Trigger = el || null;

      if (el) {
        $(el).addClass("drawer-active");
      }
    }

    function setActiveL2(el) {
      if (activeL2Trigger) {
        $(activeL2Trigger).removeClass("drawer-active");
      }

      activeL2Trigger = el || null;

      if (el) {
        $(el).addClass("drawer-active");
      }
    }

    function injectMobileHeader($container, level) {
      if (isDesktopLg()) {
        return;
      }

      const html =
        '<div class="top-0 mb-3 -mt-2 -mx-2 px-2 py-3" style="margin-left: -15px;">' +
        '  <button class="drawer-back inline-flex items-center gap-2" data-back="' +
        level +
        '">' +
        '    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">' +
        '      <path d="M15 18l-6-6 6-6" />' +
        "    </svg>" +
        "    Retour" +
        "  </button>" +
        "</div>";

      $container.prepend(html);
    }

    function openDock() {
      $dock.removeClass("hidden");
      $L1.addClass("active");

      showBackdrop();
    }

    function closeDock() {
      setActiveL1(null);
      setActiveL2(null);

      $L1.removeClass("active");
      $L2.removeClass("active");
      $L3.removeClass("active");

      $S2.empty();
      $S3.empty();

      $dock.addClass("hidden");

      hideBackdrop();

      // Also ensure mega menus are closed
      $("#megaDestinations, #megaInspirations").stop(true, true).slideUp(120).removeClass("is-open");

      $("#btnDest, #btnInspi").attr("aria-expanded", "false");
    }

    function closeL2() {
      setActiveL1(null);
      $L2.removeClass("active");
      $S2.empty();
      closeL3();
    }

    function closeL3() {
      setActiveL2(null);
      $L3.removeClass("active");
      $S3.empty();
    }

    function showStage2From(el) {
      const tplId = $(el).data("sub");

      if (!tplId) {
        closeL2();
        return;
      }

      const $tpl = $(tplId);

      if ($tpl.length === 0) {
        closeL2();
        return;
      }

      $S2.html($tpl.html());
      injectMobileHeader($S2, 2);

      $L2.addClass("active");
      $L3.removeClass("active");
      $S3.empty();

      setActiveL1(el);
      setActiveL2(null);
    }

    function showStage3From(el) {
      const tplId = $(el).data("sub");
      const $tpl = $(tplId);

      if ($tpl.length === 0) {
        closeL3();
        return;
      }

      const heroMarkup =
        '<figure class="drawer-hero-right">' +
        '  <img id="drawerL3HeroImg" src="" alt="" class="hidden">' +
        '  <figcaption id="drawerL3HeroLabel" class="hidden"></figcaption>' +
        "</figure>";

      if (isDesktopLg()) {
        const markup =
          '<div class="l3-wrap">' + '  <div class="l3-list">' + $tpl.html() + "</div>" + heroMarkup + "</div>";

        $S3.html(markup);

        // Apply hero visibility based on data-hero of the clicked L2 item
        updateHero($("#drawerL3HeroImg"), $("#drawerL3HeroLabel"), el);
      } else {
        $S3.html($tpl.html());
      }

      injectMobileHeader($S3, 3);
      $L3.addClass("active");
      setActiveL2(el);

      // Update hero label when hovering links inside L3
      $S3.off(".hero");

      $S3.on("pointerenter.hero", "a", function () {
        updateHero($("#drawerL3HeroImg"), $("#drawerL3HeroLabel"), this);
      });

      $S3.on("focusin.hero", "a", function () {
        updateHero($("#drawerL3HeroImg"), $("#drawerL3HeroLabel"), this);
      });
    }

    // Expose a tiny API so we can open the drawer + go directly to a root item
    $dock.data("drawer-api", {
      openDock,
      closeDock,
      showStage2From,
    });

    // ---- Open / close buttons ----

    $("#openDrawerBtn").off("click.drawer");
    $("#openDrawerBtn").on("click.drawer", function (e) {
      e.preventDefault();
      openDock();
    });

    $("#closeDrawerBtn, #drawerBackdrop").off("click.drawer");
    $("#closeDrawerBtn, #drawerBackdrop").on("click.drawer", function (e) {
      e.preventDefault();
      closeDock();
    });

    $(document).off("keydown.drawer");
    $(document).on("keydown.drawer", function (e) {
      if (e.key === "Escape") {
        closeDock();
      }
    });

    // ---- L1 → L2 ----

    $L1.off(".drawerL1");

    $L1.on("pointerenter.drawerL1", "a.drawer-root", function () {
      if (isDesktopLg()) {
        showStage2From(this);
      }
    });

    $L1.on("focusin.drawerL1", "a.drawer-root", function () {
      if (isDesktopLg()) {
        showStage2From(this);
      }
    });

    $L1.on("click.drawerL1", "a.drawer-root", function (e) {
      const hasSub = $(this).data("sub");

      if (hasSub) {
        e.preventDefault();
        showStage2From(this);
      }
    });

    // ---- L2 → L3 (and close when hovering non-sub) ----

    $L2.off(".drawerL2");

    // Hover/focus items with data-sub
    $L2.on("pointerenter.drawerL2", "[data-sub]", function () {
      if (isDesktopLg()) {
        showStage3From(this);
      }
    });

    $L2.on("focusin.drawerL2", "[data-sub]", function () {
      if (isDesktopLg()) {
        showStage3From(this);
      }
    });

    // Hover/focus simple links without data-sub → close L3
    $L2.on("pointerenter.drawerL2", "a:not([data-sub])", function () {
      if (isDesktopLg()) {
        closeL3();
        setActiveL2(null);
      }
    });

    $L2.on("focusin.drawerL2", "a:not([data-sub])", function () {
      if (isDesktopLg()) {
        closeL3();
        setActiveL2(null);
      }
    });

    // Click on items with data-sub
    $L2.on("click.drawerL2", "[data-sub]", function (e) {
      e.preventDefault();
      showStage3From(this);
    });

    // ---- Mobile back buttons ----

    $(document).off("click.drawerBack");
    $(document).on("click.drawerBack", ".drawer-back", function () {
      const level = Number($(this).data("back"));

      if (level === 3) {
        closeL3();
      } else if (level === 2) {
        closeL2();
      }
    });

    // ---- Desktop-only: auto-close when leaving columns ----

    $L2.off("pointerleave.drawerL2");
    $L2.on("pointerleave.drawerL2", function () {
      if (!isDesktopLg()) {
        return;
      }

      clearTimeout(l2Timer);

      l2Timer = setTimeout(function () {
        const hoverL2 = $L2.is(":hover");
        const hoverL3 = $L3.is(":hover");
        const hoverTrigger = activeL1Trigger && $(activeL1Trigger).is(":hover");

        const keep = hoverL2 || hoverL3 || hoverTrigger;

        if (!keep) {
          closeL2();
        }
      }, 120);
    });

    $L3.off("pointerleave.drawerL3");
    $L3.on("pointerleave.drawerL3", function () {
      if (!isDesktopLg()) {
        return;
      }

      clearTimeout(l3Timer);

      l3Timer = setTimeout(function () {
        const hoverL3 = $L3.is(":hover");
        const hoverTrigger = activeL2Trigger && $(activeL2Trigger).is(":hover");

        const keep = hoverL3 || hoverTrigger;

        if (!keep) {
          closeL3();
        }
      }, 120);
    });
  }

  // ---------------- Hash → open mega or drawer ----------------

  function openMegaFromHash(hash) {
    if (hash === "#menu-destinations") {
      const $btn = $("#btnDest");
      const openFn = $btn.data("mega-open");
      if (typeof openFn === "function") {
        openFn();
      } else {
        $btn.trigger("click");
      }
    }

    if (hash === "#menu-envies") {
      const $btn = $("#btnInspi");
      const openFn = $btn.data("mega-open");
      if (typeof openFn === "function") {
        openFn();
      } else {
        $btn.trigger("click");
      }
    }
  }

  function openDrawerFromHash(hash) {
    const $dock = $("#drawerDock");
    if ($dock.length === 0) {
      return;
    }

    const api = $dock.data("drawer-api");
    const $L1 = $("#drawerL1");

    if (!api || typeof api.openDock !== "function" || typeof api.showStage2From !== "function") {
      // Fallback: just open the drawer if possible
      $("#openDrawerBtn").trigger("click");
      return;
    }

    api.openDock();

    let label = null;
    if (hash === "#menu-destinations") {
      label = "Destinations";
    } else if (hash === "#menu-envies") {
      label = "Envies";
    }

    if (!label) {
      return;
    }

    // Find the L1 root with that label (expects <a class="drawer-root">Destinations</a>, etc.)
    const $root = $L1
      .find("a.drawer-root")
      .filter(function () {
        return $.trim($(this).text()) === label;
      })
      .first();

    if ($root.length) {
      api.showStage2From($root[0]); // second panel already selected
    }
  }

  function initMenuHashTriggers() {
    function handleHash(rawHash) {
      const hash = rawHash || "";
      if (hash !== "#menu-destinations" && hash !== "#menu-envies") {
        return;
      }

      //  Defer opening so "click outside" handlers for this click
      //     run first and can't immediately close the freshly-opened menu.
      setTimeout(function () {
        // >=1500px → mega menu, <1500px → burger / drawer
        const isBigDesktop = window.matchMedia("(min-width: 1500px)").matches;

        if (isBigDesktop) {
          openMegaFromHash(hash);
        } else {
          openDrawerFromHash(hash);
        }
      }, 0);
    }

    // Click on deep-link anchors anywhere in the page
    $(document).on("click.menuhash", "a[href='#menu-destinations'], a[href='#menu-envies']", function (e) {
      e.preventDefault();
      handleHash(this.hash || $(this).attr("href"));
    });

    // If we land on the page with the hash already in the URL
    handleHash(window.location.hash);

    // React to manual hash changes too
    $(window).on("hashchange.menuhash", function () {
      handleHash(window.location.hash);
    });
  }

  // ---------------- Init ----------------

  $(function () {
    initStickyHeader();
    initPhoneDropdown();
    initMegaDestinations();
    initMegaInspirations();
    initDrawer();
    initMenuHashTriggers();
  });
})(jQuery);
